export const data = [
    {
      name: "Data Engineering",
      icon: "/dataengineering.png",
      description: "Data Engineering: Unlock the power of your data with our expert data engineering solutions, ensuring efficient data processing, integration, and storage for optimal business insights.",
      link:'/dataengineering',
      margin:'my-5'
    },
    {
      name: "Data Science",
      icon: "/datascience.png",
      description: "Harness advanced analytics and Generative AI to extract meaningful insights from your data. Enable smarter decision-making, and accelerate innovation across your organization.",
      link:'/datascience',
      margin:''
    },
    {
      name: "Business Intelligence",
      icon: "/businessintelligence.png",
      description: "Leverage the power of data visualization, advanced analytics, and self-serve functionality to unlock valuable insights and drive smarter business decisions with our business intelligence services.",
      link:'/businessintelligence',
      margin:'my-4'
    },
    {
      name: "Generative AI",
      icon: "/genAI.png",
      description: "We build Generative AI solutions that transform data into actionable content automating workflows, enhancing decision-making, and delivering intelligent, scalable business outcomes.",
      link:'/generativeai',
      margin:'my-4'
    }]